<template>
  <div class="mb-8 divide-y divide-slate-200">
    <div v-for="(item, index) in displayedItems" :key="index" class="flex justify-start pb-4"
         :class="containerClasses(index)">
      <div class="flex items-center justify-center rounded bg-slate-100 min-w-[3rem]"
           :class="small ? 'h-6 w-6' : 'h-12 w-12'"
           :style="`background:${getColorAtIndex(index, list.length, 0.15)};color:${getColorAtIndex(index, list.length, 1)};`">
        <Component :is="icon" :class="small ? 'h-3 w-3' : 'h-5 w-5'"/>
      </div>
      <div class="text-slate-900 text-sm">
        <p v-if="typeof item === 'string'" class="font-bold">{{ item }}</p>
        <template v-else>
          <div v-if="item.primary || item.type" class="font-bold -mt-0.5">
            {{ getItemCompletionMessage(item?.completion, item?.primary, item?.type) }}
            <span v-if="item.primary">{{ item.primary }}</span>
            <span v-if="item.primary && item.type"> | </span>
            <span v-if="item.type">{{ item.type }}</span>
          </div>
          <div v-if="item.title" :class="!(item.primary || item.type) && 'font-bold'">{{ item.title }}</div>
          <div v-if="item.rank" class="text-slate-400">
            <span class="font-medium">Self Rated {{ item.rank }}/10</span> <span
            class="italic opacity-80">– "{{ getRankMessage(item.rank) }}"</span></div>
          <div v-if="item.subtitle" class="text-slate-400">{{ item.subtitle }}</div>
          <div v-if="item.start || item.end" class="text-slate-400">{{ formatTenure(item.start, item.end) }}</div>
          <div v-if="item.description" class="mt-4 text-slate-600">{{ item.description }}</div>
          <a v-if="item.link" :href="item.link" target="_blank" class="mt-4 flex items-center text-primary-600 hover:underline">
            View
            <ArrowTopRightOnSquareIcon class="ml-1 h-4 w-4"/>
          </a>
        </template>
      </div>
    </div>
    <div v-if="list.length > 3" class="mt-3 -mb-6 flex justify-center pt-6">
      <button @click="toggleShowMore" class="text-primary-500">
        {{ showMoreText }}
      </button>
    </div>
  </div>
</template>

<script setup>
import {computed, ref} from "vue";
import {getColorAtIndex} from "../helpers/OpportunityFunctions.js";
import {formatTenure} from "../helpers/FormatDates.js";
import {getItemCompletionMessage, getRankMessage} from "../helpers/CandidateFunctions.js";
import {ArrowTopRightOnSquareIcon} from "@heroicons/vue/24/outline/index.js";

const props = defineProps({
  small: Boolean,
  list: {
    type: Array,
    default: () => [],
  },
  icon: {
    type: [Object, Function],
    required: true,
  },
});

const showMore = ref(false);

const toggleShowMore = () => showMore.value = !showMore.value;

const displayedItems = computed(() => {
  return showMore.value ? props.list : props.list.slice(0, 3);
});

const showMoreText = computed(() => {
  return showMore.value ? "Show less" : "Show more";
});

const containerClasses = (index) => {
  const classes = [];

  if (index !== 0) classes.push("pt-6");

  if (index !== props.list.length - 1) classes.push("pb-6");

  if (typeof props.list[index] === "string") classes.push("items-center");
  else classes.push("items-start gap-4 md:gap-6");

  if (props.small) classes.push("gap-2 md:gap-3");
  else classes.push("items-start gap-4 md:gap-6");

  if (typeof props.list[index] === "string" || !props.list[index].description) classes.push("items-center");

  return classes.join(" ");
};
</script>
